import React, { useState, useEffect } from "react";
import {
  Navbar,
  Container,
  Nav,
  Image,
  NavDropdown,
  Button,
} from "@themesberg/react-bootstrap";
//import Logo from "../assets/img/eurastech-logo_new.jpg";
import Logo from "../assets/img/web_rubi_icon.png";
import { Routes } from "../routes";
import { useAuth, logout } from "../auth";
import { FormattedMessage, useIntl } from "react-intl";

const LangBar = () => {
  const [lang, setLang] = localStorage.getItem("lang") ?? "ko";
  //const intl = useIntl();

  const onLangClick = (evt) => {
    evt.preventDefault();
    const value = evt.currentTarget.getAttribute("value");
    localStorage.setItem("lang", value);
    window.location.reload();
  };

  return (
    <Nav className="justify-content-end border-bottom border-light bg-white">
      <NavDropdown
        title="Language"
        id="basic-nav-dropdown"
        className="outline-primary"
        style={{ zIndex: "2000" }}
      >
        <NavDropdown.Item value="ko" onClick={onLangClick}>
          한국어
        </NavDropdown.Item>
        <NavDropdown.Item value="ru" onClick={onLangClick}>
          РУССКИЙ
        </NavDropdown.Item>
        <NavDropdown.Item value="en-US" onClick={onLangClick}>
          ENGLISH
        </NavDropdown.Item>
      </NavDropdown>
    </Nav>
  );
};

export default () => {
  const [logged] = useAuth();
  console.log(logged);

  return (
    <>
      <LangBar></LangBar>
      <Navbar
        variant="dark"
        expand="lg"
        bg="white"
        className="navbar-transparent sticky-top justify-content-between px-3"
      >
        <Navbar.Brand className="me-lg-3">
          <Image src={Logo} width="120" height="96" draggable="false" />
        </Navbar.Brand>
        <Nav className="navbar-nav-hover align-items-lg-center">
          {!logged ? (
            <>
              <Nav.Link href={Routes.Signin.path} className="text-dark">
                <FormattedMessage id="login" />
              </Nav.Link>
              <Nav.Link href={Routes.Signup.path} className="text-dark">
                <FormattedMessage id="signup" />
              </Nav.Link>{" "}
            </>
          ) : (
            <>
              <Nav.Link href={Routes.AttentionsInfo.path} className="text-dark">
                <FormattedMessage id="attention" />
              </Nav.Link>
              <Nav.Link href={Routes.MatchingInfo.path} className="text-dark">
                <FormattedMessage id="matching" />
              </Nav.Link>
              <Nav.Link onClick={logout} className="text-dark">
                <FormattedMessage id="logout" />
              </Nav.Link>
              <Nav.Link href={Routes.EditProfile.path} className="text-dark">
                <FormattedMessage id="editProfile" />
              </Nav.Link>
            </>
          )}
        </Nav>
      </Navbar>
    </>
  );
};
